module.exports = {
  locales: ["da", "en"],
  defaultLocale: "da",
  pages: {
    "*": ["common"],
    "/home/[[...home]]": ["home"],
    "rgx:^/authorize": ["authorize"],
    "rgx:^/next/admin": ["admin", "rails"],
    "rgx:^(/en)?/service": ["admin", "rails", "service"],
    "rgx:^(/en)?/(requests|partners)": ["admin", "rails", "authorize"],
    "rgx:^(/en)?/share": ["admin", "rails"],
  },
};
